import { IMap } from '../interfaces';

export type Normalizable = string | Date | number | boolean | null | undefined;

export function autoMapper<T>(entity: T[], key: string) {
  const map: IMap<T> = {};

  entity.forEach((item) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    map[item[key]] = item;
  });

  return map;
}

export function mapObject<T>(obj: IMap<T>, cb: (item: T) => T) {
  const clone: IMap<T> = {};

  Object.keys(obj).forEach((key) => {
    clone[key] = cb(obj[key]);
  });

  return clone;
}

export function convertMapToList<T>(obj: IMap<T>): T[] {
  return obj ? Object.keys(obj).map((key) => obj[key]) : [];
}

export function uniqueItems<T>(entity: T[], key: string) {
  return entity
    .filter((e: T, i: number, arr: T[]) => arr.findIndex((en: T) => en[key as keyof T] === e[key as keyof T]) === i)
    .map((m: T) => m[key as keyof T]);
}

export const getError = <T>(err: T) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (Array.isArray((err as any)?.errors)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return constructErrorMessage({ message: (err as any).errors });
  }
  const error = err as { response: { data: { message: string } } };
  const validationErrors = err as { response: { data: { errors: { [key: string]: string } } } };
  return constructErrorMessage(
    validationErrors?.response?.data?.errors || { message: [error?.response?.data?.message] },
  );
};

const constructErrorMessage = (errorObj?: IMap<string>) => {
  let errorMsg = '';
  for (const key in errorObj) {
    if (errorObj[key as string].length) {
      for (const msg of errorObj[key as string]) {
        if (msg) {
          errorMsg = `${errorMsg} ${msg}`;
        }
      }
    }
    errorMsg = `${errorMsg} \n`;
  }

  if (!errorMsg.trim().length) {
    errorMsg = 'Something went wrong. Please contact your administrator';
  }
  return errorMsg.trim();
};

export const cloneArray = <T>(items: T[]): T[] => {
  return JSON.parse(JSON.stringify(items));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertStringToNull = (data: any) => {
  const obj = data;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function isObject(val: any) {
    return val && typeof val === 'object' && !Array.isArray(val);
  }

  for (const key in obj) {
    if (obj[key] === '') {
      obj[key] = null;
    } else if (isObject(obj[key])) {
      convertStringToNull(obj[key]);
    } else if (Array.isArray(obj[key])) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      obj[key].forEach((item: any) => {
        if (isObject(item)) {
          convertStringToNull(item);
        }
      });
    }
  }

  return obj;
};

export const sortArray = <T>(items: T[], field: keyof T, order: 'asc' | 'desc', includeCasing = false): T[] => {
  return [...items].sort((a, b) => {
    const compareA = includeCasing ? (String(a[field]) || '').toLowerCase() : a[field];
    const compareB = includeCasing ? (String(b[field]) || '').toLowerCase() : b[field];

    if (order === 'asc') return compareA < compareB ? -1 : 1;
    else if (order === 'desc') return compareA < compareB ? 1 : -1;
    return 0;
  });
};

export const isMatchIgnoreCase = (value: string | undefined, target: string | undefined) => {
  return value?.toLowerCase() === target?.toLowerCase();
} ;
